import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';

import styles from './EditJob.module.css';
import FormField from '../../../components/UI/UpdatedFormUI/FormField/FormField';
import BubbleButton from '../../../components/UI/Buttons/BubbleButton/BubbleButton';
import FormOptionField from '../../../components/UI/UpdatedFormUI/FormOptionField/FormOptionField';

function CompensationAndbenefits({ formik, activeSteps, setActiveSteps, saveAsDraftOnly, updateJobOnly, id, draftLoading, submitLoading, formik_values_status }) {

    const { t, i18n } = useTranslation();
    const isRTL = i18n.language === 'ar';
    const [localDraftLoading, setLocalDraftLoading] = useState(false);
    const [localUpdateLoading, setLocalUpdateLoading] = useState(false);

    // Check if visa is provided and should be pre-selected in benefits
    useEffect(() => {
        if (formik.values.visaProvided === 'Yes') {
            // Check if 'Visa' is already in otherBenefit array
            if (!formik.values.otherBenefit.includes('Visa')) {
                // Add 'Visa' to the otherBenefit array
                formik.setFieldValue('otherBenefit', [...formik.values.otherBenefit, 'Visa']);
            }
        }
    }, [formik.values.visaProvided]);

    const salaryRateOptions = [
        { value: 'per_hour', label: t("CompensationAndbenefits.Per_hour") },
        { value: 'per_day', label: t("CompensationAndbenefits.Per_day") },
        { value: 'per_week', label: t("CompensationAndbenefits.Per_week") },
        { value: 'per_month', label: t("CompensationAndbenefits.Per_month") },
        { value: 'per_year', label: t("CompensationAndbenefits.Per_year") },
    ];

    const otherBenefitOptions = [
        { value: 'Visa', label: t("CompensationAndbenefits.Visa") },
        { value: 'Medical', label: t("CompensationAndbenefits.Medical") },
        { value: 'Accommodation', label: t("CompensationAndbenefits.Accommodation") },
        { value: 'Family Visa', label: t("CompensationAndbenefits.Family_Visa") },
        { value: 'Family Medical', label: t("CompensationAndbenefits.Family_Medical") },
        { value: 'Other Allowances', label: t("CompensationAndbenefits.Other_Allowances") }
    ];

    // Custom handler for otherBenefit checkboxes
    const handleBenefitChange = (e) => {
        const { name, value, checked } = e.target;
        
        // If it's the Visa benefit and visaProvided is Yes, prevent unchecking
        if (value === 'Visa' && formik.values.visaProvided === 'Yes') {
            return; // Don't allow changing this checkbox
        }
        
        // For other benefits, proceed with normal functionality
        const currentBenefits = [...formik.values[name]];
        
        if (checked) {
            // Add the value if it doesn't exist
            if (!currentBenefits.includes(value)) {
                formik.setFieldValue(name, [...currentBenefits, value]);
            }
        } else {
            // Remove the value
            formik.setFieldValue(
                name,
                currentBenefits.filter((benefit) => benefit !== value)
            );
        }
    };

    return (
        <>
            <div className={`${styles.row} ${styles.rowContainer} `}>
                <div className={styles.inputContainer}  >
                    <label className={styles.label}>{t("CompensationAndbenefits.Salary_Range")}</label>
                    <div className={styles.salaryContainer} >
                        <div className={`${styles.salaryField} ${styles.fullWidth}`}>
                            <label className={`${styles.salaryLabel} ${styles.labelSize}`} >{t("CompensationAndbenefits.From")}</label>
                            <div className={styles.fullWidth}>
                                <FormField
                                    name="salary_low"
                                    type="text"
                                    hasBorder
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.salary_low}
                                    error={formik.touched.salary_low && formik.errors.salary_low}
                                    prefix="$"
                                />
                            </div>
                        </div>
                        <div className={`${styles.salaryField} ${styles.fullWidth}`}>
                            <label className={`${styles.salaryLabel} ${styles.labelSize}`} >{t("CompensationAndbenefits.To")}</label>
                            <div className={styles.fullWidth}>
                                <FormField
                                    name="salary_high"
                                    type="text"
                                    hasBorder
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.salary_high}
                                    error={formik.touched.salary_high && formik.errors.salary_high}
                                    prefix="$"
                                />
                            </div>
                        </div>
                    </div>
                    <p className={styles.currencyNote}>{t("CompensationAndbenefits.currency_conversion_note")}</p>
                </div>
                <div className={`${styles.inputContainer} ${styles.salaryRateContainer}`} >
                    <FormOptionField
                        name="salaryRate"
                        label={t("CompensationAndbenefits.Salary_Rate")}
                        type="radio"
                        dark
                        options={salaryRateOptions}
                        onChange={formik.handleChange}
                        value={formik.values.salaryRate}
                        error={formik.touched.salaryRate && formik.errors.salaryRate}
                    />
                </div>
            </div>
            <div className={styles.inputContainer}
                style={{
                    ...(isRTL ? { marginLeft: 'auto', } : {})
                }}  >
                <label className={styles.label}>{t("CompensationAndbenefits.Working_hours_per_week")}</label>
                <div className={styles.salaryContainer}
                 style={{
                    ...(isRTL ? { flexDirection:'row-reverse',marginLeft: 'auto' } : {})
                }} 
                >
                    <div className={`${styles.salaryField} ${styles.fullWidth}`} 
                    style={{
                    ...(isRTL ? { flexDirection:'row-reverse' } : {})

                    }}
                    >
                        <label className={`${styles.salaryLabel} ${styles.labelSize}`}>{t("CompensationAndbenefits.From")}</label>
                        <div className={`  ${styles.fullWidth}`}>
                            <FormField
                                name="working_hours_per_week_from"
                                type="text"
                                hasBorder
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.working_hours_per_week_from}
                                error={formik.touched.working_hours_per_week_from && formik.errors.working_hours_per_week_from}
                            />
                        </div>
                    </div>
                    <div className={`${styles.salaryField} ${styles.fullWidth}`} 
                    style={{
                        ...(isRTL ? { flexDirection:'row-reverse' } : {})
                    }}
                    >
                        <label className={`${styles.salaryLabel} ${styles.labelSize}`}>{t("CompensationAndbenefits.To")}</label>
                        <div className={`  ${styles.fullWidth}`}>
                            <FormField
                                name="working_hours_per_week_to"
                                type="text"
                                hasBorder
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.working_hours_per_week_to}
                                error={formik.touched.working_hours_per_week_to && formik.errors.working_hours_per_week_to}
                            />
                        </div>
                    </div>
                </div >
            </div >
            <div className={styles.checkBoxContainer}>
                <label className={styles.label} >{t("CompensationAndbenefits.Other_Benefit")}</label>
                <div className={styles.gridContainer}  >
                    {otherBenefitOptions.map((item) => {
                        // Check if this is the Visa option and should be read-only
                        const isVisaAndReadOnly = item.value === 'Visa' && formik.values.visaProvided === 'Yes';
                        
                        return (
                            <div key={item.value} style={{ textWrap: "nowrap" }}>
                                <FormOptionField
                                    name="otherBenefit"
                                    dark
                                    type="checkbox"
                                    options={[item]}
                                    onChange={handleBenefitChange}
                                    value={formik?.values?.otherBenefit?.filter((e) => e === item.value)[0]}
                                    error={formik?.touched?.otherBenefit && formik?.errors?.otherBenefit}
                                    disabled={isVisaAndReadOnly}
                                    // Add a special class if this is the read-only Visa checkbox
                                    className={isVisaAndReadOnly ? styles.disabledCheckbox : ''}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
            <div style={{ display: "flex", gap: 10 }}>
                <BubbleButton dark headerDarkButton
                    // type="submit"
                    onClick={() => {
                        if (formik.values.city && formik.values.country && formik.values.category && formik.values.title) {
                            setActiveSteps(activeSteps - 1)
                        }
                    }}
                    style={{ padding: '10px 20px' }}>{t('signupHeader.back')}</BubbleButton>

                <BubbleButton
                    dark
                    headerDarkButton
                    type="submit"
                    onClick={() => {
                        if (formik.values.working_hours_per_week_from && formik.values.working_hours_per_week_to) {
                            setActiveSteps(activeSteps + 1)
                        }
                    }}
                    style={{ padding: '10px 20px' }}
                >
                    {t("CompensationAndbenefits.Next")}
                </BubbleButton>
                
                {(!id || (formik_values_status === 'draft')) && (
                    <BubbleButton
                        dark
                        headerDarkButton
                        onClick={async () => {
                            setLocalDraftLoading(true);
                            await saveAsDraftOnly();
                            setLocalDraftLoading(false);
                        }}
                        style={{ padding: '10px 20px', marginLeft: '10px' }}
                        disabled={localDraftLoading || localUpdateLoading || draftLoading || submitLoading}
                    >
                        {localDraftLoading ? (
                            <div className={styles.buttonLoader}>
                                <div className={styles.spinnerSmall}></div>
                                <span>{t('forms.login.processing')}</span>
                            </div>
                        ) : (
                            t('job.save_draft', 'Save Draft')
                        )}
                    </BubbleButton>
                )}
                
                {(id && formik_values_status !== 'draft') && (
                    <BubbleButton
                        dark
                        headerDarkButton
                        onClick={async () => {
                            setLocalUpdateLoading(true);
                            await updateJobOnly();
                            setLocalUpdateLoading(false);
                        }}
                        style={{ padding: '10px 20px', marginLeft: '10px' }}
                        disabled={localDraftLoading || localUpdateLoading || draftLoading || submitLoading}
                    >
                        {localUpdateLoading ? (
                            <div className={styles.buttonLoader}>
                                <div className={styles.spinnerSmall}></div>
                                <span>{t('forms.login.processing')}</span>
                            </div>
                        ) : (
                            t('job.update', 'Update')
                        )}
                    </BubbleButton>
                )}
            </div>
        </>
    );
}

export default CompensationAndbenefits;
